"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Minus = function Minus(props) {
  return _react.default.createElement("svg", {
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M18.75 11.9792H6.25002C6.11189 11.9792 5.97941 12.0341 5.88174 12.1318C5.78406 12.2295 5.72919 12.3619 5.72919 12.5001C5.72919 12.6382 5.78406 12.7707 5.88174 12.8684C5.97941 12.966 6.11189 13.0209 6.25002 13.0209H18.75C18.8882 13.0209 19.0206 12.966 19.1183 12.8684C19.216 12.7707 19.2709 12.6382 19.2709 12.5001C19.2709 12.3619 19.216 12.2295 19.1183 12.1318C19.0206 12.0341 18.8882 11.9792 18.75 11.9792Z",
    fill: props.foregroundColor
  }));
};

Minus.defaultProps = {
  altText: "Minus",
  foregroundColor: "#2D5AB4"
};
Minus.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Minus;
exports.default = _default;